<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <ui-no-content-box
            v-if="!salesTableList.length"
            :load="loading"
            :reload-btn="false"
            btn-text="Adicionar Tabela"
            icon="fas fa-table"
            text="Crie suas tabelas de vendas e defina os planos de pagamentos."
            @click="newTableConfirm"
        />

        <div v-else>
            <div v-if="loadingFirstTable" class="load-indicator">
                <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
            </div>

            <div v-else class="sales">

                <!-- @start .sales-menu -->
                <div class="sales-menu">
                    <div
                        v-for="(tab, index) in salesTableList"
                        :key="tab.id"
                        class="sales-menu-list-item"
                        :class="{active: tab.id === activeTab}"
                        @click="selectTable(index)"
						:data-ui="'sales-table-div-drag-table-' + index"
                    >
                        <span class="draggable">:</span>
                        {{ tab.name }}
                    </div>

                    <ui-button design="light sales-menu-button-clone" @click="newTableConfirm" :data-ui="'sales-table-button-add-table'" >
                        <i class="far fa-plus"/>
                    </ui-button>
                </div>
                <!-- @end .sales-menu -->


                <!-- @start .sales-content -->
                <div class="sales-content">

                    <!-- @start .sale -->
                    <div v-if="loadingOnSelectTable" class="load-indicator">
                        <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                    </div>
                    <template v-else>
                        <div class="sale">
						
                            <!-- @start .sale-actions -->
                            <div class="section sale-actions">			
                                <a v-if="parseInt(form.data.id) && printTableConfig && user.user_group === 'admin'"
									class="link-permissions"
									@click.prevent="handlePermissionsClick"
									:class="{ 'disabled-link': saveTableLoad }">
                                    <i class="fal fa-user-lock"/>
                                    Permissões de visualização
                                </a>
                                <ui-button design="danger md" @click="removeConfirm" :data-ui="'sales-table-button-remove-table'" :disabled="saveTableLoad">Excluir</ui-button>
                                <ui-button design="success md" @click="submit" :data-ui="'sales-table-button-save-table'" :disabled="saveTableLoad">
									<ui-load-indicator v-if="saveTableLoad" bg-color="#e7e9f4" color="#69D296" :h="16" :stroke="8" />
									<span style="margin-left:3px" v-if="saveTableLoad">Salvando...</span>
									<span v-else>Salvar Tabela</span>
								</ui-button>
                            </div>
                            <!-- @end .sale-actions -->


                            <!-- @start .sale-header -->
                            <form class="section sale-header">
                                <div class="col -left">
                                    <input data-ui="'sales-table-input-table-name'" v-model="form.data.name" class="title" type="text" name="title" autocomplete="off" />
                                    <div class="subtitle">
                                        <strong>Atualização em:</strong>
                                        {{ form.data.updated_at | moment("DD [de] MMMM [de] YYYY [às] HH:mm") }}
                                    </div>
                                </div>
                                <div class="col -right form-sale-dates">
                                    <ui-datepicker-range
										:data-ui-start="'sales-table-input-start-date'"
										:data-ui-end="'sales-table-input-end-date'"										
                                        v-model="rangeDate"
                                        label-start="Data inicial"
                                        label-end="Data final"
                                    />
                                </div>
                            </form>
                            <!-- @end .sale-header -->


                            <!-- @start .sale-config -->

                            <div class="section sale-config">
                                <form class="sale-config-form">
                                    <div v-show="form.message" v-add-html="form.message" class="message mb-15"/>

                                    <div class="form-row" >
                                        <div v-if="form.data.simulationType !== 'vertical'" class="col">
                                            <ui-select data-ui="'sales-table-select-table-type'" v-model="form.data.type" :clearable="false" label="Tipo de Tabela" line-height>
                                                <option
                                                    v-for="(type, index) in typeOptions"
                                                    :key="index"
                                                    :value="type.value"
                                                    :selected="form.data.type === type.value">
                                                    {{ type.label }}
                                                </option>
                                            </ui-select>
                                        </div>

                                        <div v-if="enableVerticalSimulator && product.availability.type == 'vertical'" class="col">
                                            <ui-select :useTouchedValidation="true"
												:disabled="Boolean(parseInt(form.data.id))" :data-ui="'sales-table-select-simulation-type'" required v-model="form.data.simulationType" :clearable="false" label="Tipo de Simulação" line-height>
                                                <option
                                                    v-for="(type, index) in simulationTypeOptions"
                                                    :key="index"
                                                    :value="type.value"
                                                    :selected="form.data.simulationType === type.value">
                                                    {{ type.label }}
                                                </option>
                                            </ui-select>
                                        </div>

                                        <div v-if="data.integration_erp_id" class="col">
                                            <ui-input :data-ui="'sales-table-input-sales-model'" v-model="form.data.sales_model" type="tel" label="Modelo de Vendas" />
                                        </div>

                                        <div class="col">
                                            <ui-input data-ui="'sales-table-input-discount'" v-model="form.data.discount" type="tel" percent label="Desconto" group="%" />
                                        </div>

                                        <div class="col">
                                            <ui-input data-ui="'sales-table-input-monthly-tax'" v-model="form.data.monthly_rate" type="tel" percent required label="Taxa Mensal" group="%" />
                                        </div>

                                        <div class="col">
                                            <ui-input data-ui="'sales-table-input-yearly-tax'"  v-model="yearlyRateComputed" type="tel" percent label="Taxa Anual" group="%" disabled/>
                                        </div>

                                        <div v-if="enableVerticalSimulator && form.data.simulationType == 'vertical'" class="switch-daily-rate">
                                            <ui-switch
												data-ui="'sales-table-switch-daily-rate'"
                                                v-model="form.data.data.daily_rate"
                                                :checked="form.data.data.daily_rate"
                                                label="<strong>Taxa Diária</strong>"
                                                design="sm"
                                            />
                                        </div>
                                    </div>

                                    <div class="input-group">
                                        <label class="label" for="sale-config-observations">Observações</label>
                                        <textarea data-ui="sales-table-textarea-observations" id="sale-config-observations" v-model="form.data.observations"/>
                                    </div>
                                </form>
                            </div>
                            <!-- @end .sale-config -->

                            <ui-modal-permissions-sales-table />
                            <!-- @start .sale-settings -->
                            <div class="section sale-settings">
                                <div class="sale-settings-form">
                                    <div class="buttons">
                                        <ui-button data-ui="sales-table-button-simulation-rules" design="primary md" @click="openModal('simulator-rules')">Regras do Simulador</ui-button>
                                        <ui-button data-ui="sales-table-button-comission-rules" design="primary md" @click="openModal('commission-rules')">Regras de Comissão</ui-button>
                                        <ui-button data-ui="sales-table-button-readjust-rules" design="primary md" v-if="$mx_userIsAdmin && parseInt(this.salesTableList[this.selected].id)" @click="openAdjustmentInstallmentsModal('adjustable-installments')">Reajuste de Parcelas</ui-button>
                                        <ui-button v-if="product.availability?.integration_erp?.type === 'uau'" design="primary md" @click="openModal('config-date-proposal')">	
                                            Datas de Envio da Proposta
                                        </ui-button>
                                    </div>

                                    <div class="form">
                                        <strong class="title">Unidade para simulação teste:</strong>

                                        <ui-select v-model="form.blockId" :clearable="false" @input="setUnityOptions" data-ui="sales-table-select-block" >
                                            <option
                                                v-for="(block, index) in availabilityBlockOptions"
                                                :key="index"
                                                :value="block.value"
                                                :selected="block.value === form.blockId">
                                                {{ block.label }}
                                            </option>
                                        </ui-select>

                                        <ui-select v-model="form.unityId" :clearable="false" @input="inputUnityHandler" data-ui="sales-table-select-unity" >">
                                            <option
                                                v-for="(unity, index) in blockUnityOptions"
                                                :key="`${index}-${unity.id}`"
                                                :value="unity.id"
                                                :selected="unity.id === form.unityId">
                                                {{ `Unidade ${unity.number}` }}
                                            </option>
                                        </ui-select>

                                        <div class="badge primary">
                                            <small>Metragem</small>
                                            <span v-if="form.unity" data-ui="sales-table-span-square-value">{{ form.unity.area }} m²</span>
                                            <span v-else>0 m²</span>
                                        </div>

                                        <div class="badge warning">
                                            <small>Valor Unidade</small>
                                            <span v-if="form.unity" data-ui="sales-table-span-square-value">{{ form.unity.cost | currencyBRL }}</span>
                                            <span v-else>{{ 0 | currencyBRL}}</span>
											
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- @end .sale-settings -->

                            <!--
								Fluxos de Pagamentos / Payments Flow
							-->
                            <!-- @start .sale-flows -->
                            <ui-sales-table-flow-manager
                                :data.sync="form.data.sales_table_flow"
                                :form="form"
                                :unity="form.unity"
                                @update="setTable"
                            />
                            <!-- @end .sale-flows -->

                        </div>
                    </template>
                    <!-- @end .sale -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator, uiNoContentBox } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiDatepickerRange, uiInput, uiSelect, uiSwitch } from '@/components/ui/form'
import uiSalesTableFlowManager from './components/sales-table-flow-manager'
import AdjustableInstallments from './components/adjustable-installments'
import uiModalPermissionsSalesTable from '@/components/ui-facilita/modal-permissions-sales-table'

import { product, salesTable } from '@/services/axios'

import { currencyBRL } from '@/filters'
import calculations from '@/mixins/calculations/salesTable'
import helpers from '@/mixins/helpers'
import { helpersMixin, permissionsMixin } from '@/mixins'

import { mapGetters } from 'vuex'
import { storage } from '@/services/storage'
const moment = require('moment')
require('moment/locale/pt-br')


const defaultFormData = (data) => {
    return {
        id: 'random-' + Math.floor((Math.random() * Date.now()) + 1),
        name: 'Nova Tabela',
        start_date: moment().format('YYYY-MM-DD'),
        end_date: null,
        type: 'price',
        show_pv: 'yes',
        discount: '',
        monthly_correction: '',
        monthly_rate: '',
        commission: '',
        observations: '',
        availability_id: data.id || null,
        sales_table_flow: [],
		simulationType: 'horizontal',
        data: {
            entryShowAllDays: false,
            allowExtend: true,
			daily_rate: false
        }
    }
}

export default {
	name: 'step-four-sales',

	components: {
		uiDatepickerRange,
		uiButton,
		uiInput,
		uiSelect,
		uiSalesTableFlowManager,
		uiNoContentBox,
		uiLoadIndicator,
		uiSwitch,
		AdjustableInstallments,
		uiModalPermissionsSalesTable
	},


	filters: {
		currencyBRL,
	},

	mixins: [
		helpers,
		calculations,
		permissionsMixin
	],

	props: {
		productId: {
			type:[Number, String],
			required: true,
			default:""
		},
		/** Dados da disponibilidade do produto */
		data: {
			type: Object,
			required: false,
			default() {
				return {
					id: 0,
					sales_table: []
				}
			}
		}
	},

	data() {
		return {
			saveTableLoad: false,
			activeTab: 0,
			unsubscribe: null,
			loading: true,
			loadingFirstTable: true,
			loadingOnSelectTable: false,
			rangeDate: {
				start: '',
				end: ''
			},
			form: {
				message: '',
				status: '',
				errors: [],
				unityId: null,
				unity: null,
				blockId: null,
				fields: {
					name: {
						required: true
					},
					start_date: {
						required: true
					},
					end_date: {
						required: true
					},
                    simulationType: {
						required: true
					},
					type: {
						required: true
					},
					discount: {
						required: false
					},
					monthly_rate: {
						required: true
					},
					observations: {
						required: false
					},
					availability_id: {
						required: true
					},
				},
				data: {}
			},
			salesTableList: [],
			selected: 0,
			typeOptions: [
				{ label: 'SAC', value: 'sac' },
				{ label: 'PRICE', value: 'price' },
				{ label: 'SACOC', value: 'sacoc' }
			],
			simulationTypeOptions:[
				{label:'Horizontal', value:'horizontal'},
				{label:'Vertical', value:'vertical'}
			],
			availabilityBlockOptions: [],
			blockUnityOptions: [],
			enableVerticalSimulator: false,
			readjustableInstallmentsItens: {},
			enableVerticalSimulator: false,
			printTableConfig: false,
		}
	},
	computed: {
		...mapGetters('product', {
			product: 'getProduct'
		}),

		/**
			* Computed property para calcular a taxa anual a partir da taxa mensal,
			* utilizando a função de cálculo facConvertInterest
			*/
		yearlyRateComputed() {
			const rate = parseFloat(this.form.data.monthly_rate)
			if(rate || rate === 0) {
				let frequency = {

					bimonthly       : this.facConvertInterest(rate, 2).toFixed(4),
					quarterly       : this.facConvertInterest(rate, 3).toFixed(4),
					four_monthly    : this.facConvertInterest(rate, 4).toFixed(4),
					semester        : this.facConvertInterest(rate, 6).toFixed(4),
					yearly          : this.facConvertInterest(rate, 12).toFixed(4)
				}

				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				if(!this.form.data.data || typeof this.form.data.data != "object") this.form.data.data = {}
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.form.data.data.frequency = {...frequency}
				return this.facConvertInterest(rate, 12).toFixed(4)
			}
			return ''
		},
		user() {
			return JSON.parse(storage.get('user_logged'))
		},
	},

	watch: {
		/**
		 * Range property para formatar as datas inicial e final da tabela de vendas
		 */
		rangeDate(newEnter) {
			this.form.data.start_date = moment(newEnter.start).format('YYYY-MM-DD')
			this.form.data.end_date = moment(newEnter.end).format('YYYY-MM-DD')
		}
	},

	created() {
		/** Subscreve para uma mutation */
		this.unsubscribe = this.$store.subscribe((mutation) => {
			/** Atualiza o conteúdo da tabela */
			if (mutation.type === "salesTable/SET_SALES_TABLE_CONFIG") {
				this.$set(this.form, 'data', { ...mutation.payload })
			}
		})
		/** Ouve o evento que vem do modal de confirmação para excluir a tabela de vendas */
		this.$root.$on("modal-msg-event-delete-sales-table", (payload) => {
			if(payload.action)
				this.remove()
		})
		/** Ouve o evento que vem do modal de confirmação para criação de tabelas */
		this.$root.$on("add-new-empty-sales-table", () => {
			this.$root.$emit('modal-close-modal-sales-table-new')
			this.addEmptyTable()
		})

		/** Carrega as opções de tabelas de vendas para clonagem */
		this.$root.$on("modal-open-modal-sales-table-clone", () => {
			this.setSalesTableCloneOptions()
		})
 
		/** Clona uma tabela existente de acordo com a seleção do usuário no modal */
		this.$root.$on("clone-existing-sales-table", (payload) => {
			this.cloneTable(payload)
		})
		/**Boolean retornando se o simulador vertical está habilitado ou não*/
		this.enableVerticalSimulator = Boolean(parseInt(JSON.parse(storage.get('get-configs-data')).enableVerticalSimulator))

		/**Atualiza o defaultConfig na tabela selecionada*/
		this.$root.$on('updated-config', (data) => {
			this.salesTableList[this.selected].default_config = data.salesTableDefaultConfig
		})
	},

	beforeMount() {
		if(this.user.user_group === 'admin'){
			salesTable.getTableConfigurations().then((response) => {
				let configs = response.data.data
				this.printTableConfig = configs.find((config) => config.name == "permissionsTableFlow").active
			}).catch((error) => this.$toastr.e(error.data.msg || 'Erro ao buscar permissão de visualização.'))
		}
	
		if (this.data.sales_table && this.data.sales_table.length) {
			this.salesTableList = [...this.data.sales_table]
			 // Extrai default_config de cada item dentro do salesTableList e cria um novo array
			 this.readjustableInstallmentsItens = this.salesTableList.map(item => ({
				id: item.id,
				default_config: item.default_config
			 }));
			this.selectTable(0)
		}
		setTimeout(() => {
			this.loadingFirstTable = false
		}, 1618)
		this.setAvailabilityBlockOptions()
	},

	mounted() {
		setTimeout(() => {
			this.loading = false
		}, 1618)
	},

	beforeDestroy() {
		this.unsubscribe()
		this.$root.$off("modal-msg-event-delete-sales-table")
		this.$root.$off("add-new-empty-sales-table")
		this.$root.$off("modal-open-modal-sales-table-clone")
		this.$root.$off("clone-existing-sales-table")
		this.$root.$off('updated-config')
	},

	methods: {
		handlePermissionsClick() {
			if (this.saveTableLoad) return;
			this.openModalPermissions();
		},
		/**
			* Seleciona a tab a ser mostrada
			*/
		selectTab(index) {
			this.activeTab = index
		},
		/**
			* Abrir o Modal
			*/
		openModal(name){
			this.$store.dispatch('salesTable/setSalesTableConfig', this.form.data)
			this.$root.$emit('modal-open-' + name)
		},
		openAdjustmentInstallmentsModal(name){
			this.$root.$emit('modal-open-' + name)
			this.$root.$emit('send-data',  this.readjustableInstallmentsItens[this.selected]);
		},
		/**
			* Fechar o modal
			*/
		closeModal(){
			this.$root.$emit('modal-close-' + name)
		},
		/**
			* Monta o select de quadras ou torres/andares de acordo com
			* as unidades da disponibilidade
			*/
		setAvailabilityBlockOptions() {
			let options = {}
			const vm = this
			if (this.data.units && this.data.units.length) {
				for (const unity of this.data.units) {
					let value = ''
					let label = ''
					switch (vm.data.type) {
						case 'vertical':
							value = `${unity.floor}_${unity.block}`
							label = parseInt(unity.floor) ?
								`Torre ${unity.block} / Andar ${unity.floor}` :
								`Torre ${unity.block} / Térreo`
							break
						default:
							value = `${unity.pos_y}_${unity.stage}`
							label = `Quadra ${unity.block}`
							break
					}
					if (typeof options[value] === 'undefined') options[value] = { value, label }
				}
			}

			this.availabilityBlockOptions = [...Object.values(options)]
			if (this.availabilityBlockOptions.length) {
				this.form.blockId = this.availabilityBlockOptions[0].value
				this.setUnityOptions()
			}
		},
		/**
			* Computed property que gera as opções do select de unidades de acordo
			* com a quadra ou torre/andar selecionada
			*/
		 setUnityOptions() {
			if (this.form.blockId) {
				let value = this.form.blockId.split('_')
				let block = value.length ? value[0] : '' // Em empreendimento vertical é o andar (floor)
				let stage = value.length ? value[1] : '' // Em empreendimento vertical é o bloco (block)

				product.getBlockUnits(this.productId, this.data.type, block, stage)
					.then(response => {
						this.blockUnityOptions = [...response.data]

						if (this.blockUnityOptions.length) {
							this.form.unityId = this.blockUnityOptions[0].id
							this.inputUnityHandler()
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					})
			}
		},
		/**
			* Busca as tabelas de vendas de acordo com a disponibilidade para o processo de clonagem
			*/
		setSalesTableCloneOptions() {
			if (this.product && this.product.availability_id) {
				salesTable.getAvailabilitySalesTable(this.product.availability_id)
					.then(response => {
						this.$store.dispatch('salesTable/setSalesTableCloneOptions', [...response.data])
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					})

			} else {
				this.$toastr.e('O produto não possui uma disponibilidade vinculada')
			}
		},
		/**
			* Abre o modal de confirmação para verificar se
			* será criada uma nova tabela ou se será clonada
			*/
		newTableConfirm() {
			this.$root.$emit('modal-open-modal-sales-table-new')
		},
		/**
			* Altera os dados do formulário de acordo com a tabela de vendas selecionada
			*/
		setTable(item) {
			 if (item) {
				this.emitUpdateFlowAndSendData(item);
				const index = this.salesTableList[this.selected].sales_table_flow.findIndex(flow => flow.id === item.id)
				if (index !== -1) {
					/** Se o item já existe, atualize-o */
					this.$set(this.salesTableList[this.selected].sales_table_flow, index, item)
				} else {
					/** Caso contrário, adicione-o ao array */
					this.salesTableList[this.selected].sales_table_flow.push(item)
				}
    		}
			if (this.salesTableList[this.selected]) {
				this.$set(this.form, 'data', { ...this.salesTableList[this.selected] })
				this.rangeDate.start = this.form.data.start_date ? this.form.data.start_date : null
				this.rangeDate.end = this.form.data.end_date ? this.form.data.end_date : null
				this.selectTab(this.salesTableList[this.selected].id)
				this.$store.dispatch('salesTable/setSalesTable', this.salesTableList[this.selected])
				this.emitUpdateFlowAndSendData(this.salesTableList[this.selected]);
				this.$store.dispatch('salesTable/setSeriesDefaultConfigs', this.salesTableList[this.selected].default_config)
			}
		},
		emitUpdateFlowAndSendData(item) {
			if (!item) return;
			this.$root.$emit('update-flow', {
				salesTableId: item.sales_table_id || item.id,
				salesTableItems: item.sales_table_item
			});
			this.$root.$emit('send-data', this.readjustableInstallmentsItens[this.selected]);
		},
		/**
			* Atualiza os dados da tabela de vendas na listagem, de acordo com os dados no
			* formulário
			*/
		updateTableList() {
			/** Verifica se o objeto não está vazio */
			if (Object.keys(this.form.data).length !== 0 && this.form.data.constructor === Object) {
				this.$set(this.salesTableList, this.form.data)
			}
		},
		/**
			* Escolhe uma tabela e altera os dados do formulário
			*/
		selectTable(index) {
			this.loadingOnSelectTable = true
			this.updateTableList()
			this.form.message = ''
			this.selected = index
			this.inputUnityHandler()
			setTimeout(() => {
				this.loadingOnSelectTable = false
				this.setTable()
			}, 404)
		},
		/**
			* Cria uma nova tabela de vendas vazia
			*/
		addEmptyTable() {
			setTimeout(() => {
				this.loadingFirstTable = false
			}, 1618)

			this.$set(this.salesTableList, this.salesTableList.length, { ...defaultFormData(this.data) })
			this.selectTable(this.salesTableList.length - 1)
		},
		/**
			* Realiza a requisição que clona uma tabela de vendas de acordo com o ID
			* e busca os dados da nova tabela
			*/
		cloneTable(id) {
			salesTable.clone(id)
				.then(response => {
					this.$set(this.salesTableList, this.salesTableList.length, { ...response.data })
					this.selectTable(this.salesTableList.length - 1)
					this.$store.dispatch('salesTable/setSalesTableCloneOptions', [])
					this.$root.$emit('modal-close-modal-sales-table-clone-remove-load')
					this.$toastr.s('Tabela clonada com sucesso!')
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log('error', error)
				})
		},
		/**
			* Valida a propriedade required dos campos do formulário
			*/
		validateRequired(field) {
			const required = this.form.fields[field].required
			const validation = this.form.data[field] || parseInt(this.form.data[field]) === 0

			return (required && validation) || !required
		},
		/**
			* Valida os campos do formulário de acordo com diferentes conjuntos de regras
			*/
		validateForm() {
			let valid = true
			let message = '<ul>'

			if (!this.validateRequired('name')) {
				valid = false
				message += '<li>É necessário informar o nome da tabela de vendas.</li>'
			}

			if (!this.validateRequired('start_date')) {
				valid = false
				message += '<li>É necessário informar a data inicial da tabela de vendas.</li>'
			}
       
			if (!this.validateRequired('end_date')) {
				valid = false
				message += '<li>É necessário informar a data final da tabela de vendas.</li>'
			}

			if (!this.validateRequired('type')) {
				valid = false
				message += '<li>É necessário selecionar o tipo da tabela de vendas.</li>'
			}

			if (!this.validateRequired('simulationType') && this.product.availability.type == 'vertical' && this.enableVerticalSimulator) {
				valid = false
				message += '<li>É necessário informar o tipo de simulação.</li>'
			}

			if (!this.validateRequired('discount')) {
				valid = false
				message += '<li>É necessário informar o desconto.</li>'
			}

			if (!this.validateRequired('monthly_rate')) {
				valid = false
				message += '<li>É necessário informar a taxa mensal.</li>'
			}

			if (this.form.data.simulationType == 'vertical' && Boolean(this.form.data.monthly_rate == 0)) {
				valid = false
				message += '<li>É necessário que haja uma taxa mensal maior que 0 em simulações verticais.</li>'
			}

			if (!this.validateRequired('observations')) {
				valid = false
				message += '<li>É necessário informar as observações.</li>'
			}

			if (!this.validateRequired('availability_id')) {
				valid = false
				message += '<li>É necessário informar o ID da disponibilidade da tabela de vendas.</li>'
			}

			message += '</ul>'

			return { valid, message }
		},
		/**
			* Valida os dados do formulário, submita os dados e mostra as mensagens de erro
			* caso seja necessário
			*/
		submit() {
			const validation = this.validateForm()
			if (validation.valid) {
				this.$set(this.form, 'message', '')
				this.submitForm()
			} else {
				this.$set(this.form, 'message', validation.message)
			}
		},
		/**
			* Atualiza ou cria uma tabela de acordo com os dados do formulário
			*/
		submitForm() {
			this.saveTableLoad = true;
			this.$set(this.form, 'errors', [])
			if (this.form.data.id && !String(this.form.data.id).includes('random')) {
				salesTable.update('', this.form.data.id, this.form.data)
					.then(response => {
						this.$set(this.salesTableList, this.selected, { ...response.data.data })
						this.$set(this.form, 'data', response.data.data)
						this.$toastr.s(response.data.msg)
						this.$root.$emit('event-submit-flows')
						this.$store.dispatch('salesTable/setSalesTable', response.data.data)
						this.emitUpdateFlowAndSendData(this.salesTableList[this.selected]);
					})
					.catch(error => {
						if (typeof error.data.details === 'object') this.$set(this.form, 'errors', { ...error.data.details })
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					}).finally(() => {
						this.saveTableLoad = false;
					})
			} else {
				salesTable.create('', this.form.data)
					.then(response => {
						this.$set(this.salesTableList, this.selected, { ...response.data.data })
						this.$set(this.form, 'data', response.data.data)
						this.selectTab(response.data.data.id)
						this.$toastr.s(response.data.msg)
						this.emitUpdateFlowAndSendData(this.salesTableList[this.selected]);
						this.$store.dispatch('salesTable/setSeriesDefaultConfigs', this.salesTableList[this.selected].default_config)
						this.$store.dispatch('salesTable/setSalesTable', response.data.data)
					})
					.catch(error => {
						if (typeof error.data.details === 'object') this.$set(this.form, 'errors', { ...error.data.details })
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					}).finally(() => {
						this.saveTableLoad = false;
					})
			}
		},
		/**
			* Remove o objeto da tabela do array de listagem
			*/
		removeTable() {
			this.$delete(this.salesTableList, this.selected)
			this.selected = this.selected ? this.selected - 1 : 0
			this.setTable()
		},
		/**
			* Remove uma tabela de vendas
			*/
		remove() {
			const id = this.salesTableList[this.selected].id
			if (String(id).includes('random')) {
				this.removeTable()
			} else {
				salesTable.delete('', id)
					.then(response => {
						this.$toastr.s(response.data.msg)
						this.removeTable()
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					})
			}
		},
		/**
			* Emite o evento para abrir o modal de confirmação de exclusão
			*/
		removeConfirm() {
			this.$root.$emit('modal-msg-open-delete-sales-table')
		},
		/**
			* Seta a unidade de acordo com o ID selecionado
			*/
		inputUnityHandler() {
			if (this.form.unityId && this.blockUnityOptions.length) {
				this.form.unity = this.alasql(`SELECT * FROM ? WHERE id = ${this.form.unityId}`, [this.blockUnityOptions])[0]
				this.form.unityId = this.form.unity.id
			} else {
				this.form.unity = null
			}
		},
		/**
			* Evento disparado ao ordenar / drag n drop
			*/
		dragEndHandler(event) {
			//Verifica se houve alteração / reordenação
			const hasChanged = event.newIndex !== event.oldIndex

			console.log('dragend', hasChanged,  event)
		},
		openModalPermissions(){
			this.$root.$emit('modal-open-permissions', () => {})
		}	
	}
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>